var _jsxFileName = "/media/data/Sandbox/soapbox-defake/app/soapbox/components/ui/text/text.tsx";
const _excluded = ["align", "className", "direction", "family", "size", "tag", "theme", "tracking", "transform", "truncate", "weight"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import classNames from 'clsx';
import React from 'react';
const themes = {
  default: 'text-gray-900 dark:text-gray-100',
  danger: 'text-danger-600',
  primary: 'text-primary-600 dark:text-accent-blue',
  muted: 'text-gray-700 dark:text-gray-600',
  subtle: 'text-gray-400 dark:text-gray-500',
  success: 'text-success-600',
  inherit: 'text-inherit',
  white: 'text-white'
};
const weights = {
  normal: 'font-normal',
  medium: 'font-medium',
  semibold: 'font-semibold',
  bold: 'font-bold'
};
const sizes = {
  xs: 'text-xs',
  sm: 'text-sm',
  md: 'text-base leading-5',
  lg: 'text-lg',
  xl: 'text-xl',
  '2xl': 'text-2xl',
  '3xl': 'text-3xl'
};
const alignments = {
  left: 'text-left',
  center: 'text-center',
  right: 'text-right'
};
const trackingSizes = {
  normal: 'tracking-normal',
  wide: 'tracking-wide'
};
const transformProperties = {
  normal: 'normal-case',
  uppercase: 'uppercase'
};
const families = {
  sans: 'font-sans',
  mono: 'font-mono'
};

/** UI-friendly text container with dark mode support. */
const Text = /*#__PURE__*/React.forwardRef((props, ref) => {
  const {
    align,
    className,
    direction,
    family = 'sans',
    size = 'md',
    tag = 'p',
    theme = 'default',
    tracking = 'normal',
    transform = 'normal',
    truncate = false,
    weight = 'normal'
  } = props,
        filteredProps = _objectWithoutProperties(props, _excluded);

  const Comp = tag;
  const alignmentClass = typeof align === 'string' ? alignments[align] : '';
  return /*#__PURE__*/React.createElement(Comp, _extends({}, filteredProps, {
    ref: ref,
    style: {
      textDecoration: tag === 'abbr' ? 'underline dotted' : undefined,
      direction
    },
    className: classNames({
      'cursor-default': tag === 'abbr',
      truncate: truncate,
      [sizes[size]]: true,
      [themes[theme]]: true,
      [weights[weight]]: true,
      [trackingSizes[tracking]]: true,
      [families[family]]: true,
      [alignmentClass]: typeof align !== 'undefined',
      [transformProperties[transform]]: typeof transform !== 'undefined'
    }, className),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 111,
      columnNumber: 7
    }
  }));
});
export { Text as default };